import { BUTTON_STYLE_MAP, DISABLED_BUTTON_STYLE_MAP, type ButtonStyle } from '../button.types';

// classes that apply to all buttons, regardless of style or state
const BASE_CLASSES = 'content-center flex items-center justify-center';

export function chooseBusyStyle(specifiedStyle: ButtonStyle): string {
	switch (specifiedStyle) {
		case 'DESTRUCTIVE_PRIMARY':
			return BUTTON_STYLE_MAP.BUSY_DESTRUCTIVE_PRIMARY;
		case 'DESTRUCTIVE_SECONDARY':
			return BUTTON_STYLE_MAP.BUSY_DESTRUCTIVE_SECONDARY;
		case 'DESTRUCTIVE_TERTIARY':
			return BUTTON_STYLE_MAP.BUSY_DESTRUCTIVE_TERTIARY;
		case 'SECONDARY':
			return BUTTON_STYLE_MAP.BUSY_SECONDARY;
		case 'TERTIARY':
			return BUTTON_STYLE_MAP.BUSY_TERTIARY;
		case 'INTERNAL':
			return BUTTON_STYLE_MAP.BUSY_INTERNAL_PRIMARY;
		case 'INTERNAL_SECONDARY':
			return BUTTON_STYLE_MAP.BUSY_INTERNAL_SECONDARY;
		case 'INTERNAL_TERTIARY':
			return BUTTON_STYLE_MAP.BUSY_INTERNAL_TERTIARY;
		default:
			return BUTTON_STYLE_MAP.BUSY_PRIMARY;
	}
}

export function chooseDisabledStyle(specifiedStyle: ButtonStyle): string {
	const baseDisabledStyle = BUTTON_STYLE_MAP.DISABLED;
	if (specifiedStyle === 'SECONDARY' || specifiedStyle === 'INTERNAL_SECONDARY' || specifiedStyle === 'DESTRUCTIVE_SECONDARY') {
		return `${DISABLED_BUTTON_STYLE_MAP.SECONDARY} ${baseDisabledStyle}`;
	} else if (specifiedStyle === 'TERTIARY' || specifiedStyle === 'INTERNAL_TERTIARY' || specifiedStyle === 'DESTRUCTIVE_TERTIARY') {
		return `${baseDisabledStyle} ${DISABLED_BUTTON_STYLE_MAP.TERTIARY}`;
	} else if (specifiedStyle === 'TERTIARY_GREY') {
		return `${baseDisabledStyle} ${DISABLED_BUTTON_STYLE_MAP.TERTIARY_GREY}`;
	} else {
		return `${baseDisabledStyle} ${DISABLED_BUTTON_STYLE_MAP.PRIMARY}`;
	}
}

export function chooseClasses(specifiedStyle: ButtonStyle, isBusy: boolean | undefined, disabled: boolean | undefined): string {
	if (isBusy) {
		return `${BASE_CLASSES} ${chooseBusyStyle(specifiedStyle)}`;
	} else if (disabled) {
		return `${BASE_CLASSES} ${chooseDisabledStyle(specifiedStyle)}`;
	} else {
		return `${BASE_CLASSES} ${BUTTON_STYLE_MAP[specifiedStyle]}`;
	}
}
